import { render } from "./PlacementMapping.vue?vue&type=template&id=22c66005&scoped=true"
import script from "./PlacementMapping.vue?vue&type=script&lang=js"
export * from "./PlacementMapping.vue?vue&type=script&lang=js"

import "./PlacementMapping.vue?vue&type=style&index=0&id=22c66005&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c66005"]])

export default __exports__